<template>
  <h3>Денежные потоки (ДП) по исходящему бизнесу</h3>
  <div class="block">
    <p>Для формирования денежных потоков по исходящему бизнесу необходимо:</p>
    <ul>
        <li>Загрузить файл «Перестрахование» на отчетную дату</li>
        <li>Загрузить файлы с денежными потоками (годовыми и/или месячными) на ту же отчетную дату</li>
    </ul>
    <p>При загрузке файлов ДП по исходящему бизнесу автоматически формируются расчеты по следующим сущностям:</p>
    <ul>
        <li>Доля перестраховщиков в оплаченных убытках</li>
        <li>Возмещения от перестраховщиков в части расходов на урегулирование (прям.)</li>
        <li>Возмещения от перестраховщиков в части расходов на урегулирование (проч.)</li>
        <li>Возмещения от перестраховщиков в части расходов на урегулирование (судебн.)</li>
        <li>Доля перестраховщиков в регрессных требованиях</li>
        <li>Доля перестраховщиков в ГОТС</li>
    </ul>
    <h5>ДП ООЧП (по исходящему бизнесу)</h5>
    <h6>Годовые ДП ООЧП</h6>
    <p>1.	Прогноз выручки</p>
    <p>Перед таблицами с расчетами на интерфейсе указаны версия расчета и прогноз доли в заработанной премии из загрузочного файла «ДП ООЧП (мес. исходящее)».</p>
    <img src="@/assets/img/guide/oocp-re-forecast.png" alt="" srcset="">
    <p>Для остальных сущностей в начале каждого раздела отражается прогноз состоявшихся убытков вместо прогноза выручки, который считается на основе прогноза выручки из загрузки и коэффициентов убыточности по когортам из оплаченных убытков.</p>
    <img src="@/assets/img/guide/oocp-re-forecast-share.png" alt="" srcset="">
    <p>2.	Коэффициенты возмещения убытков</p>
    <p>Далее в расчетах по оплаченным убыткам рассчитываются коэффициенты убыточности по когорте. Для данных расчетов используется Заработная премия и окончательная убыточность из таблицы «Доля перестраховщиков в резерве убытков» из раздела «Перестрахование».</p>
    <p>Пользователь может выбрать коэффициент убыточности по каждому периоду для каждой когорты, которая есть в загрузке для ДП ООЧП (исходящее). Доступны следующие опции:</p>
    <ul>
        <li>Средний за последний год <i>(4 квартала)</i></li>
        <li>Средний за последние два года <i>(8 кварталов)</i></li>
        <li>За последний квартал</li>
        <li>Ручной ввод</li>
    </ul>
    <img src="@/assets/img/guide/coef-return-by-cohort-re.png" alt="" srcset="">
    <p>Для других сущностей рассчитывается «Выбор доли, % в убытках». Для выбора коэффициентов доступны следующие опции:</p>
    <ul>
        <li>Средний за последний год <i>(4 квартала)</i></li>
        <li>Средний за последние два года <i>(8 кварталов)</i></li>
        <li>За последний квартал</li>
        <li>Ручной ввод</li>
    </ul>
    <img src="@/assets/img/guide/share-choose-re.png" alt="" srcset="">
    <p>Для метода «Доля от резерва» также доступен выбор среднего коэффициента за последний год из итогового РУ:</p>
    <img src="@/assets/img/guide/share-choose-detail-re.png" alt="" srcset="">
    <p>3.	Выбор паттерна урегулирования</p>
    <p>Далее для всех сущностей выбирается паттерн, который рассчитывается с помощью факторов развития Доли перестраховщиков в резерве убытков из раздела «Перестрахование» из таблицы «Выбор коэффициентов развития доли перестраховщиков в убытках». В данной таблице можно выбрать паттерн, полученный на основе каждого из методов, которые были созданы для Доли перестраховщиков в резерве убытков в разделе «Перестрахование». При нажатии на название метода выбирается целиком соответствующий паттерн выплат.</p>
    <img src="@/assets/img/guide/dp-pattern-choose-re.png" alt="" srcset="">
    <p>Для других сущностей доступен выбор паттерна:</p>
    <ul>
        <li>на базе расчета резерва убытков </li>
        <li>на базе расчета соответствующей сущности</li>
    </ul>
    <img src="@/assets/img/guide/dp-pattern-choose-detail-re.png" alt="" srcset="">
    <p>Данные также берутся из раздела «Перестрахование» из таблицы «Выбор коэффициентов развития доли перестраховщиков в убытках».</p>
    <p>4.	Прогноз будущих возмещений</p>
    <p>Последние таблицы посвящены Прогнозу будущих возмещений. В расчете представлено несколько видов таблиц:</p>
    <ul>
        <li>Прогноз будущих возмещений по когортам (на рисунке это таблицы 6, 7, 8)</li>
    </ul>
    <p>Данные таблицы перемножают прогноз выручки (или прогноз состоявшихся убытков) по когорте, выбранную убыточность и выбранный паттерн выплат. Для расчета «Доля перестраховщиков в оплаченных убытках» выбранная убыточность берется из соответствующих таблиц по когорте.</p>
    <ul>
        <li>Прогноз возмещений выплат на Т = 0 (на рисунке это таблица 9)</li>
    </ul>
    <p>Данная таблица также перемножает прогноз выручки (или прогноз состоявшихся убытков) из Т = 0, выбранную убыточность и выбранный паттерн выплат. Для расчета «Доля перестраховщиков в оплаченных убытках» выбранная убыточность берется из соответствующих таблиц по когорте.</p>
    <ul>
        <li>Прогноз возмещений выплат по всем когортам (на рисунке это таблица 5)</li>
    </ul>
    <p>Данная таблица суммирует результаты полученных возмещений по всем когортам.</p>
    <img src="@/assets/img/guide/dp-forecast-re.png" alt="" srcset="">
    <h5>ДП ООЧП (по исходящему бизнесу)</h5>
    <p>1.	Прогноз доли в заработанной премии</p>
    <p>Перед таблицами с расчетами на интерфейсе указаны версия расчета и прогноз доли в заработанной премии из загрузочного файла. Для месячных ДП ООЧП (исходящее) прогноз доли в заработанной премии делятся на действующий и новый типы бизнеса.</p>
    <img src="@/assets/img/guide/oocp-forecast-loss-types.png" alt="" srcset="">
    <p>Для остальных сущностей в начале каждого раздела отражается прогноз состоявшихся убытков вместо прогноза выручки, который считается на основе прогноза выручки из загрузки и коэффициентов убыточности по когортам из оплаченных убытков.</p>
    <p>2.	Коэффициенты убыточности</p>
    <p>Далее в расчетах по оплаченным убыткам рассчитываются коэффициенты убыточности по когорте. Для данных расчетов используется Заработная премия и окончательная убыточность из таблицы «Доля перестраховщиков в резерве убытков» из раздела «Перестрахование».</p>
    <p>Пользователь может выбрать коэффициент убыточности по каждому периоду для каждой когорты, которая есть в загрузке для месячных ДП ООЧП (исходящее). Доступны следующие опции:</p>
    <ul>
        <li>Средний за последний год <i>(4 квартала)</i></li>
        <li>Средний за последние два года <i>(8 кварталов)</i></li>
        <li>За последний квартал</li>
        <li>Ручной ввод</li>
    </ul>
    <img src="@/assets/img/guide/dp-coef-choose-re.png" alt="" srcset="">
    <p>Для других сущностей рассчитывается таблица «Выбор доли, %». В данную таблицу выгружаются методы, созданные в разделе «Перестрахование» для каждой сущности. Для выбора коэффициентов доступны следующие опции:</p>
    <ul>
        <li>Средний за последний год <i>(4 квартала)</i></li>
        <li>Средний за последние два года <i>(8 кварталов)</i></li>
        <li>За последний квартал</li>
        <li>Ручной ввод</li>
    </ul>
    <img src="@/assets/img/guide/dp-share-choose.png" alt="" srcset="">
    <p>3.	Выбор паттерна</p>
    <p>Далее для всех сущностей выбирается паттерн, который рассчитывается с помощью факторов развития Доли перестраховщиков в резерве убытков из раздела «Перестрахование» из таблицы «Выбор коэффициентов развития доли перестраховщиков в убытках». В данной таблице можно выбрать паттерн из всех методов, которые были созданы для Доли перестраховщиков в резерве убытков. При нажатии на название метода выбирается целиком соответствующий паттерн выплат.</p>
    <img src="@/assets/img/guide/dp-pay-pattern-choose-re.png" alt="" srcset="">
    <p>Для других сущностей данные также берутся из раздела «Перестрахование» из таблицы «Выбор коэффициентов развития доли перестраховщиков в убытках».</p>
    <img src="@/assets/img/guide/dp-reg-pattern-choose-re.png" alt="" srcset="">
    <p>4.	Месячный паттерн урегулирования</p>
    <p>Данная таблицы распределяет факторы развития из раздела «Перестрахование» по месяцам на основе двух методов:</p>
    <ul>
        <li>Распределение по месяцам пропорционально времени</li>
        <li>Распределение по месяцам по линейной интерполяции</li>
    </ul>
    <p>В оплаченных убытках паттерн рассчитывается на базе расчета из Доли перестраховщиков в резерве убытков.</p>
    <img src="@/assets/img/guide/month-pattern-re.png" alt="" srcset="">
    <p>В других сущностях помимо резерва убытков, также берется паттерн из Доли перестраховщиков в резерве убытков.</p>
    <p>5.	Прогноз будущих выплат</p>
    <p>Последние таблицы посвящены Прогнозу будущих выплат. В расчете представлено несколько фильтров:</p>
    <ul>
        <li>Когорта</li>
        <li>Тип бизнеса (действующий или новый)</li>
    </ul>
    <img src="@/assets/img/guide/oocp-forecast-result.png" alt="" srcset="">
    <h5>Заполнение шаблона</h5>
    <h6>ДП ООЧП Месячные</h6>
    <p>После проведения расчетов по всем сущностям ПО производит заполнение шаблона в части ООЧП по в соответствие с выбором фильтров «Когорта» и «Тип бизнеса». Для отображения расчетов по сущностям в шаблоне требуется провести расчеты по данным сущностям в ДП.</p>
    <img src="@/assets/img/guide/oocp-template-month-re.png" alt="" srcset="">
    <h6>ДП ООЧП Годовые</h6>
    <p>После проведения расчетов по всем сущностям ПО производит заполнение шаблона в части ООЧП по тем когортам, которые были поданы в загрузочном файле. Для отображения расчетов по сущностям в шаблоне требуется провести расчеты по данным сущностям в ДП. </p>
    <img src="@/assets/img/guide/oocp-template-underate-month-re.png" alt="" srcset="">
  </div>
  <div class="block">
    <h5>ДП ОВТ (по исходящему бизнесу)</h5>
    <h6>Годовые ДП ОВТ</h6>
    <p>Расчеты в ДП ОВТ годовых проходят следующим образом:</p>
    <ol>
        <li>Берется инкрементальный треугольник из созданных расчетов в разделе «Перестрахование» (смотри «Персонализация расчетов»)</li>
        <li>На основе выбранного расчета выстраиваются факторы развития</li>
        <li>На основе факторов развития рассчитывается таблица «Доля урегулирования в периоде»</li>
        <li>На основе доли урегулирования рассчитывается таблица «Высвобождение по периодам»</li>
        <li>На основе выбранного резерва в разделе «Обзор результата» и предположений о высвобождении по периодам (п.4 выше) достраивается инкрементальный и кумулятивный треугольники</li>
        <li>На основе достроенного инкрементального треугольника рассчитываются ожидаемые потоки</li>
        <li>В таблице «Данные для аллокации»:</li>
        <ul>
            <li>первая таблица рассчитывает коэффициенты распределения использую данные для аллокации</li>
            <li>вторая таблица подтягивает данные из загрузочного файла</li>
        </ul>
    </ol>
    <img src="@/assets/img/guide/dp-allocation-re.png" alt="" srcset="">
    <p>В годовых расчетах по ДП ОВТ представлена возможность персонализировать свои расчеты с помощью фильтров.</p>
    <h6>Персонализация расчетов</h6>
    <p>В годовых ДП ОВТ (исходящее) доступны следующие фильтры для персонализации расчетов:</p>
    <p>1. Треугольник развития возмещений убытков из расчета (выбор треугольников из разных расчетов, созданных в разделе «Перестрахование»)</p>
    <img src="@/assets/img/guide/loss-triangle-select-re.png" alt="" srcset="">
    <p>2. Используются факторы развития доли в РУ по моменту</p>
    <img src="@/assets/img/guide/factors-loss-select-ovt-re.png" alt="" srcset="">
    <p>3. Драйвер для аллокации по когортам (выбор типа убытков для аллокации по когортам)</p>
    <img src="@/assets/img/guide/allocation-by-cohorts-re.png" alt="" srcset="">
    <p>Первый фильтр («Треугольник развития возмещений убытков из расчета») позволяет выбрать треугольник развития доли перестраховщиков в убытках, на основе которого будут посчитаны денежные потоки по произошедшим, но неурегулированным убыткам. В зависимости от выбранного расчета меняется инкрементальный и кумулятивный треугольники в ДП ОВТ (исходящее) (измененный треугольник можно посмотреть в таблице «Кумулятивный треугольник развития»).</p>
    <img src="@/assets/img/guide/dp-triangle-re.png" alt="" srcset="">
    <p>Второй фильтр дает возможность рассчитать факторы развития на основе оплаты убытков или ручного ввода. Для всех сущностей предусмотрена опция «Ручной ввод» для факторов развития. При выборе данной опции следует вручную указать факторы развития в таблице «Паттерн урегулирования, ручной ввод».</p>
    <img src="@/assets/img/guide/dp-header-re.png" alt="" srcset="">
    <p>Результаты выбранных опций в данном фильтре можно посмотреть в таблице «Факторы развития», которая отображает факторы развития, которые будут использоваться в дальнейших расчетах.</p>
    <img src="@/assets/img/guide/factors-evolution-select-ovt-re.png" alt="" srcset="">
    <p>Третий фильтр влияет на таблицу «Данные для аллокации по когортам». В нем доступны три опции:</p>
    <ul>
        <li>Заявленные убытки</li>
        <li>Оплаченные убытки</li>
        <li>Понесенные убытки</li>
    </ul>
    <p>Данный фильтр нужен для выбора драйвера, который будет использован для аллокации произошедших, но неурегулированных убытков по когортам. При выборе разных опций меняются суммы распределенных убытков в соответствии с выбранным драйвером.</p>
    <img src="@/assets/img/guide/allocation-data-by-cohorts-re.png" alt="" srcset="">
    <h5>Месячные ДП ОВТ</h5>
    <p>Расчеты в ДП ОВТ годовых проходят следующим образом:</p>
    <ol>
        <li>1.	Берется инкрементальный треугольник из расчета (смотри «Персонализация расчетов»)</li>
        <li>2.	На основе выбранного расчета выстраиваются факторы развития</li>
        <li>3.	На основе факторов развития рассчитывается Доля урегулирования в периоде</li>
        <li>4.	На основе доли урегулирования рассчитывается высвобождение доли перестраховщиков в резерве по периодам</li>
        <li>5.	На основе выбранного резерва в разделе «Обзор результата» и высвобождения по периодам достраивается инкрементальный и кумулятивный треугольники</li>
        <li>6.	На основе достроенного инкрементального треугольника рассчитываются ожидаемые потоки</li>
        <li>7.	В таблице «Данные для аллокации»:</li>
        <ul>
            <li>первая таблица подтягивает данные из загрузочного файла</li>
            <li>вторая таблица рассчитывает коэффициенты распределения использую данные для аллокации</li>
        </ul>
    </ol>
    <p>В годовых расчетах по ДП ОВТ (исходящее) представлена возможность персонализировать свои расчеты с помощью фильтров.</p>
    <h5>Персонализация расчетов</h5>
    <p>В годовых ДП ОВТ (исходящее) доступны следующие фильтры для персонализации расчетов:</p>
    <p>1. Треугольник развития возмещений убытков из расчета (выбор треугольников из разных расчетов, созданных в разделе «Перестрахование»)</p>
    <img src="@/assets/img/guide/triangle-dp-loss-select-re.png" alt="" srcset="">
    <p>2. Используются факторы развития доли в РУ по моменту</p>
    <img src="@/assets/img/guide/dp-factors-moment-re.png" alt="" srcset="">
    <p>3. Драйвер для аллокации по когортам (выбор типа убытков для аллокации по когортам)</p>
    <img src="@/assets/img/guide/dp-allocation-cohorts-select-re.png" alt="" srcset="">
    <p>4. Драйвер для разбивки РПНУ по месяцам возникновения</p>
    <img src="@/assets/img/guide/dp-rpnu-select-re.png" alt="" srcset="">
    <p>5. Переход к месячному расчету высвобождения резерва</p>
    <img src="@/assets/img/guide/dp-loss-month-select-re.png" alt="" srcset="">
    <p>Первый фильтр («Треугольник развития убытков из расчета») позволяет выбрать треугольник развития убытков, на основе которого будут посчитаны денежные потоки по произошедшим, но неурегулированным убыткам. В данном фильтре представлены все треугольники по всем расчетам, созданных в разделе «Перестрахование». Данный фильтр не появляется для сущностей, для которых не был загружен треугольник. В зависимости от выбранного расчета меняется инкрементальный и кумулятивный треугольники в ДП ОВТ (измененный треугольник можно посмотреть в таблице «Кумулятивный треугольник развития»).</p>
    <img src="@/assets/img/guide/cumulitive-triangle-re.png" alt="" srcset="">
    <p>Второй фильтр «Используются факторы развития доли в РУ по моменту» предоставляет выбор факторов развития на основе оплаты убытков или ручного ввода.</p>
    <p>Для всех сущностей предусмотрена опция «Ручной ввод» для факторов развития. При выборе данной опции следует вручную указать факторы развития в таблице «Паттерн возникновения, ручной ввод».</p>
    <img src="@/assets/img/guide/factors-select-pattern-arrow-re.png" alt="" srcset="">
    <p>Результаты выбранных опций в данном фильтре можно посмотреть в таблице «Факторы развития», которая отображает факторы развития, которые будут использоваться в дальнейших расчетах.</p>
    <img src="@/assets/img/guide/factors-evolution-ovt-re.png" alt="" srcset="">
    <p>Третий фильтр влияет на таблицу «Данные для аллокации по когортам». В нем доступны три опции:</p>
    <ul>
        <li>Заявленные убытки</li>
        <li>Оплаченные убытки</li>
        <li>Понесенные убытки</li>
    </ul>
    <p>Данный фильтр нужен для выбора драйвера, который будет использован для аллокации произошедших, но неурегулированных убытков по когортам. При выборе разных опций меняются суммы распределенных убытков.</p>
    <img src="@/assets/img/guide/allocation-data-by-cohorts-re.png" alt="" srcset="">
    <p>Также доступны расчеты по <b>текущему сервису.</b></p>
    <img src="@/assets/img/guide/allocation-by-cohorts-current-service-re.png" alt="" srcset="">
    <p>Он влияет на построение таблицы «Высвобождение резерва по периодам».</p>
    <p>Четвертый фильтр «Драйвер для разбивки РПНУ по месяцам возникновения» необходим для того, чтобы экстраполировать резерв из квартального в месячный. Доступны следующие опции:</p>
    <ul>
        <li>Пропорционально выручке (берется из месячной загрузки ДП ОВТ (исходящее))</li>
        <li>Пропорционально времени</li>
    </ul>
    <p>Данный фильтр меняет разбивку РПНУ, используя данные из раздела «обзор результата». Данный фильтр влияет на расчет достроенного треугольника. </p>
    <p>В пятом фильтре «Переход к месячному расчету высвобождения резерва» доступны следующие опции:</p>
    <ul>
        <li>Линейная интерполяция</li>
        <li>Пропорционально времени</li>
        <li>Ручной ввод</li>
    </ul>
  </div>
    <div class="block">
        <h5>Заполнение шаблона ДП по ОВТ</h5>
        <h6>ДП ОВТ Месячные</h6>
        <p>После проведения расчетов по всем сущностям ПО производит заполнение шаблона в части ОВТ. В шаблоне представлены профили убытков по всем сущностям рассчитанным раннее. Значения в расчетах зависят от фильтра «Драйвер для аллокации по когортам», который присутствует в каждой сущности. В месячных ДП ОВТ есть возможность выбрать когорту расчета:</p>
        <img src="@/assets/img/guide/ovt-template-cohort-selection.png" alt="">
        <h6>ДП ОВТ Годовые</h6>
        <p>После проведения расчетов по всем сущностям ПО производит заполнение шаблона в части ОВТ. В шаблоне представлены профили убытков по всем сущностям, рассчитанным раннее. Значения в расчетах зависят от фильтра «Драйвер для аллокации по когортам», который присутствует в каждой сущности. В годовых ОВТ убытки разбиты по андеррайтинговым годам.</p>
        <img src="@/assets/img/guide/ovt-template-by-years.png" alt="" srcset="">
  </div>
</template>
  
<script>
export default {
  name: 'CashflowsReinsurance',
}
</script>

<style scoped>
h3{
  font-size: 32px;
  color: #0074b5;
}

h5{
  margin: 20px 0px;
  font-size: 24px;
  color: #0074b5;
}

.list{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.list p{
  font-size: 16px;
}

table, th, td {
  color: #6b6f77;
  border: 1px solid black;
  border-collapse: collapse;

  margin: 20px 0px;
}

th{
  padding: 0px 10px;
}

td:nth-child(1){
  padding: 10px;
}

td:nth-child(2){
  padding: 10px 10px 10px 30px;
}

ul{
  display: flex;
  flex-direction: column;
  gap: 10px;

  margin: 20px 20px 20px 50px;
}

td ul{
  margin-left: unset;
}

ol{
  margin-left: 50px;
}

ol li{
  margin-top: 10px;
}

li p{
  margin-top: 10px;
}

ol li ul{
  margin-left: 50px;
}

p{
  margin-top: 10px;
  line-height: 20px;
}

img{
  max-width: 100%;
  margin: 50px 0px;
}
</style>
